import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'fullJurisdictionName',
    standalone: false
})
// NOTE: Only use this if you do not have an Order and Order.DisplayJurisdiction is unavailable
// this does the same thing, so if you already have access to the Order, don't do the extra work.
export class FullJurisdictionNamePipe implements PipeTransform {
    transform(jurisdiction: string, country: string) {
        if (country === 'CA') {
            switch (jurisdiction) {
                case 'BC': return 'British Columbia';
                case 'AB': return 'Alberta';
                case 'SK': return 'Saskatchewan';
                case 'MB': return 'Manitoba';
                case 'ON': return 'Ontario';
                case 'QC': return 'Quebec';
                case 'YT': return 'Yukon';
                case 'NT': return 'Northwest Territories';
                case 'NU': return 'Nunavut';
                case 'NL': return 'Newfoundland and Labrador';
                case 'NB': return 'New Brunswick';
                case 'NS': return 'Nova Scotia';
                case 'PE': return 'Prince Edward Island';
                case '_F': return 'Federal';
                case '_M': return 'Multiple';
                default: return jurisdiction;
            }
        } else if (country === 'US') {
            switch (jurisdiction) {
                case 'AL': return 'Alabama';
                case 'AK': return 'Alaska';
                case 'AZ': return 'Arizona';
                case 'AR': return 'Arkansas';
                case 'CA': return 'California';
                case 'CO': return 'Colorado';
                case 'CT': return 'Connecticut';
                case 'DE': return 'Delaware';
                case 'FL': return 'Florida';
                case 'GA': return 'Georgia';
                case 'HI': return 'Hawaii';
                case 'ID': return 'Idaho';
                case 'IL': return 'Illinois';
                case 'IN': return 'Indiana';
                case 'IA': return 'Iowa';
                case 'KS': return 'Kansas';
                case 'KY': return 'Kentucky';
                case 'LA': return 'Louisiana';
                case 'ME': return 'Maine';
                case 'MD': return 'Maryland';
                case 'MA': return 'Massachusetts';
                case 'MI': return 'Michigan';
                case 'MN': return 'Minnesota';
                case 'MS': return 'Mississippi';
                case 'MO': return 'Missouri';
                case 'MT': return 'Montana';
                case 'NE': return 'Nebraska';
                case 'NV': return 'Nevada';
                case 'NH': return 'New Hampshire';
                case 'NJ': return 'New Jersey';
                case 'NM': return 'New Mexico';
                case 'NY': return 'New York';
                case 'NC': return 'North Carolina';
                case 'ND': return 'North Dakota';
                case 'OH': return 'Ohio';
                case 'OK': return 'Oklahoma';
                case 'OR': return 'Oregon';
                case 'PA': return 'Pennsylvania';
                case 'RI': return 'Rhode Island';
                case 'SC': return 'South Carolina';
                case 'SD': return 'South Dakota';
                case 'TN': return 'Tennessee';
                case 'TX': return 'Texas';
                case 'UT': return 'Utah';
                case 'VT': return 'Vermont';
                case 'VA': return 'Virginia';
                case 'WA': return 'Washington';
                case 'WV': return 'West Virginia';
                case 'WI': return 'Wisconsin';
                case 'WY': return 'Wyoming';
                case 'DC': return 'District of Columbia';
                case 'AS': return 'American Samoa';
                case 'GU': return 'Guam';
                case 'MP': return 'Northern Mariana Islands';
                case 'PR': return 'Puerto Rico';
                case 'VI': return 'Virgin Islands';
                case 'AA': return 'Armed Forces (Americas)';
                case 'AE': return 'Armed Forces (Other)';
                case 'AP': return 'Armed Forces (Pacific)';
                default: return jurisdiction;
            }
        } else {
            return jurisdiction;
        }
    }
}